import { ReactNode } from 'react'
import ReactDOM from 'react-dom'

export const renderPortal = (renderDropDown: ReactNode): React.ReactPortal => {
  return ReactDOM.createPortal(renderDropDown && renderDropDown(), document.body)
}
